import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CardComponent } from "./card.component";
import { ActivityCardComponent } from "./activity-card/activity-card.component";
import { SafetyCardComponent } from "./safety-card/safety-card.component";

@NgModule({
  imports: [CommonModule, ActivityCardComponent, SafetyCardComponent],
  exports: [CardComponent],
  declarations: [CardComponent],
})
export class CardModule {}
